const PREFIX = 'klfb_withdraw_v1:'

export function createWithdrawalToken(): string {
  return Array.from(crypto.getRandomValues(new Uint8Array(32)), n => n.toString(16).padStart(2, '0')).join('')
}
export function rememberWithdrawalToken(todoId: string, token: string): void {
  try { localStorage.setItem(PREFIX + todoId, token) } catch { /* No claim of persistence if storage is blocked. */ }
  memory.set(todoId, token)
}
const memory = new Map<string, string>()
export function getWithdrawalToken(todoId?: string): string | null {
  if (!todoId) return null
  try { return memory.get(todoId) ?? localStorage.getItem(PREFIX + todoId) } catch { return memory.get(todoId) ?? null }
}
export async function withdrawFeedback(apiBase: string, sessionToken: string, todoId: string): Promise<{ withdrawnAt: string }> {
  const withdrawalToken = getWithdrawalToken(todoId)
  if (!withdrawalToken) throw new Error('Dieses Feedback kann nur im Browser zurückgenommen werden, in dem es gesendet wurde.')
  const response = await fetch(`${apiBase}/api/site-feedback/feedback/${encodeURIComponent(todoId)}/withdraw`, {
    method: 'POST', headers: { Authorization: `Bearer ${sessionToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ withdrawalToken }),
  })
  const json = await response.json().catch(() => ({}))
  if (!response.ok || !json.data?.withdrawnAt) throw new Error(json.error || 'Rücknahme nicht gespeichert. Erneut versuchen.')
  return json.data
}
